<div
  [class.loading]="loadingService.loading$ | async"
  class="global-loading-indicator"
  xmlns="http://www.w3.org/1999/html"
>
  <div class="background"></div>
</div>

<astrobin-header *ngIf="deviceService.lgMin()"></astrobin-header>
<astrobin-mobile-header *ngIf="!deviceService.lgMin()"></astrobin-mobile-header>

<!-- This component is always included to handle page menus regardless of viewport size -->
<astrobin-mobile-page-menu-offcanvas></astrobin-mobile-page-menu-offcanvas>

<div class="container">
  <!--  Beta banner temporarily disabled, do not commit this to git:-->
  <!--  <astrobin-beta-banner></astrobin-beta-banner>-->
  <astrobin-breadcrumb></astrobin-breadcrumb>
  <router-outlet></router-outlet>
</div>

<astrobin-mobile-footer *ngIf="deviceService.mdMax() && showFooter"></astrobin-mobile-footer>
<astrobin-footer *ngIf="deviceService.lgMin() && showFooter"></astrobin-footer>
